<template>
  <table class="table">
    <!-- <caption></caption> -->
    <thead>
      <tr class="">
        <th
          v-for="(column, indx) in columns"
          :key="indx"
          class="table__header-text"
        >
          {{ column }}
        </th>
      </tr>
    </thead>
    <tbody>
      <slot name="rows"></slot>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    columns: Array,
  },
};
</script>
